import React, { useEffect } from "react";
import {
  Image,
  ImageBackground,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import {
  BtnNavBellPng,
  BtnNavChipPng,
  BtnNavOptionsPng,
  NotificationBackgroundPng,
} from "../../../assets";
import { vars } from "../../../utils/helpers/vars";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../../navigator";
import { useDispatch, useSelector } from "react-redux";
import { selectIsLogged } from "../../../store/auth/authReducer";
import {
  selectNotifications,
  selectNotificationsLoading,
  selectUnreadCount,
} from "../../../store/userNotifications/notificationsReducer";
import { notificationsRequest } from "../../../store/userNotifications/notificationsActions";
type Nav = NativeStackNavigationProp<RootStackParamList>;

const Nav = ({
  // onOpenMessagesModal,
  onOpenSidebar,
}: {
  // onOpenMessagesModal: () => void;
  onOpenSidebar: () => void;
}) => {
  const { navigate } = useNavigation<Nav>();
  const isLogged = useSelector(selectIsLogged);
  const dispatch = useDispatch();
  const messages = useSelector(selectNotifications);
  const unread = useSelector(selectUnreadCount);
  const loading = useSelector(selectNotificationsLoading);

  useEffect(() => {
    dispatch(notificationsRequest());
  }, [dispatch]);
  return (
    <View style={styles.icons}>
      <TouchableOpacity
        style={styles.icon}
        onPress={() => {
          if (isLogged) {
            navigate("BuyPackages", { activeTab: "chips" });
          } else {
            navigate("Login");
          }
        }}
      >
        <Image source={BtnNavChipPng} style={styles.icon} />
      </TouchableOpacity>

      <TouchableOpacity
        style={styles.icon}
        onPress={() => navigate("Messages")}
      >
        <View>
          <Image source={BtnNavBellPng} style={styles.icon} />
          {unread > 0 && (
            <ImageBackground
              source={NotificationBackgroundPng}
              style={styles.notificationBadge}
            >
              <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                style={styles.notificationText}
              >
                {unread}
              </Text>
            </ImageBackground>
          )}
        </View>
      </TouchableOpacity>

      <TouchableOpacity style={styles.icon} onPress={onOpenSidebar}>
        <Image source={BtnNavOptionsPng} style={styles.icon} />
      </TouchableOpacity>
    </View>
  );
};

export default Nav;

const styles = StyleSheet.create({
  icons: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 10,
    paddingTop: 16,
    paddingRight: 16,
  },
  icon: {
    width: 45,
    height: 45,
  },
  notificationBadge: {
    position: "absolute",
    top: -12,
    right: -4,
    width: 25,
    height: 25,
    pointerEvents: "none",
    justifyContent: "center",
    alignItems: "center",
  },
  notificationText: {
    top: -2,
    color: "white",
    fontSize: 12,
    fontWeight: "bold",
  },
});
